import { Pais } from './Pais';
import { Localitat } from './localitat';
import { EstudisRealitzats } from './estudiRealitzat';
import { Alumne } from './alumne';
import { Oferta } from './oferta';
import { IdiomaPreinscripcio } from './idiomaPreinscripcio';
import { DocumentPreinscripcio } from './documentPreinscripcio';
import { ComConegut } from './comConegut';
import { Universitat } from './universitat';

export class Preinscripcio {

    public isnew = true;
    public id: number;
    public estat: number;
    public idioma: string;
    public oferta: Oferta;
    public alumne: Alumne = new Alumne();
    public coneixementMaster: ComConegut;
    public estudiRealitzat: EstudisRealitzats = new EstudisRealitzats();
    public idiomes: IdiomaPreinscripcio[] = new Array<IdiomaPreinscripcio>();
    public documents: DocumentPreinscripcio[] = new Array<DocumentPreinscripcio>();
    public urlCistellaPagamentInscripcio: string;
    public presencialitat: number;
    public conveniDobleTitulacio: boolean;
    public universitatDobleTitulacio: Universitat;
    public haPagatInscripcio = false;
    public haPagatAcceptacio = false;
    public potModificar = true;
    public preuInscripcioCalculat: number;
    public swAssabentatIdioma: boolean = null;
}



// WEBPACK FOOTER //
// ./src/app/lib/model/preinscripcio.ts